import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { LanguageProvider } from './i18n';
import './index.css';

// The entry point for the React application. We mount our
// top level App component inside a BrowserRouter which
// enables client side routing. React 18’s createRoot API
// improves performance and concurrent rendering.
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <LanguageProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </LanguageProvider>
  </React.StrictMode>
);

const initialLoader = document.getElementById('initial-loader');

if (initialLoader) {
  const hideInitialLoader = () => {
    if (!initialLoader.isConnected || initialLoader.classList.contains('is-leaving')) {
      return;
    }

    initialLoader.classList.add('is-leaving');
    window.setTimeout(() => {
      initialLoader.remove();
    }, 560);
  };

  const criticalAssets = [
    '/assets/logo-clean.png',
    '/assets/medeo-hero-v2.png',
    '/assets/tomato-cutout.png',
    '/assets/ajika-cutout.png',
    '/assets/horseradish-cutout.png',
    '/assets/ketchup-cutout.png',
    '/assets/vinegar-cutout.png',
    '/assets/apple_vinegar-cutout.png',
    '/assets/decl.png',
    '/assets/sert.png',
  ];

  const loadImage = (src) =>
    new Promise((resolve) => {
      const image = new Image();
      image.onload = resolve;
      image.onerror = resolve;
      image.src = src;
    });

  const waitForAssets = Promise.all([
    ...criticalAssets.map(loadImage),
    document.fonts?.ready || Promise.resolve(),
  ]);

  const fallbackTimeout = new Promise((resolve) => {
    window.setTimeout(resolve, 4200);
  });

  Promise.race([waitForAssets, fallbackTimeout])
    .then(hideInitialLoader)
    .catch(hideInitialLoader);
}
